import {createAction} from 'util/redux'
import {KontStammTO} from 'generated/JavaTO'

const NAMESPACE = 'KONT_STAMM/'
type RequestParams = { persNrs: number[], startDate: number, endDate: number, force: boolean }
export const kontStammFetchAction = createAction<RequestParams>(NAMESPACE + 'Fetch')
export const kontStammResponseAction = createAction<{ params: RequestParams, response: KontStammTO[] }>(NAMESPACE + 'Response')